interface StudentLike {
    studentKey?: string | number | null;
    studentNumber?: string | number;
}

/**
 * Helper function to extract a specific cookie value by name.
 * Uses split-based parsing to avoid dynamic RegExp construction.
 */
export const getStudentCookie = (name: string): string | null => {
    const prefix = `${name}=`;
    for (const part of document.cookie.split(";")) {
        const trimmed = part.trimStart();
        if (trimmed.startsWith(prefix)) {
            return trimmed.slice(prefix.length);
        }
    }
    return null;
};

/**
 * Determines and stores a student's primary ID in sessionStorage.
 * @param studentData - An object containing student data, or null to check cookies.
 * @param storageKey - The key to use for sessionStorage.
 * @returns The determined student ID or null.
 */
const SessionStudent = (studentData: StudentLike | null, storageKey: string): string | null | void => {
    if (!studentData) {
        const studentCookie = getStudentCookie("newStudentKey");
        if (studentCookie) {
            sessionStorage.setItem(storageKey, String(studentCookie));
            document.cookie = "newStudentKey=; Max-Age=0; path=/; domain=.dcsdk12.org; Secure; SameSite=Lax";
        }
        return;
    }

    const idToStore = String(studentData.studentKey ?? studentData.studentNumber ?? "");
    if (idToStore) {
        sessionStorage.setItem(storageKey, idToStore);
        return idToStore;
    } else {
        sessionStorage.removeItem(storageKey);
    }
    return null;
};

export default SessionStudent;
